'use client';
import Container from '@/components/layout/Container';
import Headings from '@/components/heading/Headings';
import SliderDisplay from '@/components/sliderDisplay/SliderDisplay';
import StaticDisplay from '@/components/staticDisplay/StaticDisplay';

export default function FeatureHighlight({
  block,
  backgroundColor,
  textColor,
  position
}) {
  const { title, subtitle, columns, mobile_slider, is_guide, _metadata } =
    block.feature;
  return (
    <>
      <section
        id={_metadata.uid + '_' + position}
        className={`standard-padding flex flex-row items-center justify-around text-center bg-[${backgroundColor}] text-[${textColor}]`}
        data-name="highlight-feature"
      >
        <Container fullPage={true}>
          {!!title && (
            <div className="min-h-[72px] sm:min-h-[48px]">
              <Headings
                headingContent={title}
                headingClassName="h4 sm:h2 px-15 sm:px-0 mb-5"
                rte="true"
              />
            </div>
          )}
          {!!subtitle && (
            <div
              dangerouslySetInnerHTML={{ __html: subtitle }}
              aria-hidden={!subtitle}
              className={`body-r sm:sh8 mx-auto mb-4 max-w-[790px] px-10 pb-4 sm:mb-10 sm:px-0`}
            />
          )}

          {mobile_slider ? (
            <SliderDisplay
              columns={columns}
              is_guide={is_guide}
              textColor={textColor}
              uid={_metadata}
            />
          ) : (
            <StaticDisplay columns={columns} />
          )}
        </Container>
      </section>
    </>
  );
}
